// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"789a2825","116":"a8c7f5a4","360":"49c3a447","457":"ab11c6ea","478":"c563c3a3","518":"9932a00c","787":"9a344a5d","791":"1ed9c56e","862":"00366e8d","880":"9cddc000","951":"6b9b4f96"}[chunkId] + ".chunk.js";
};